var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"siriContainer",staticClass:"siri-wave",style:({left: _vm.containerWidth / 2 + _vm.containerHeight / 2 + 'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }